import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  composeValidators,
  maxLength,
  minLength,
  requiredStringNoTrim,
} from './validators';

const VALID = undefined;

export const signupPasswordsMatch = values => {
  const { password, confirmPassword } = values || {};

  return (
    typeof password === 'string' &&
    typeof confirmPassword === 'string' &&
    confirmPassword.length > 0 &&
    password === confirmPassword
  );
};

export const validatePasswordConfirmation = (
  password,
  confirmPassword,
  requiredMessage,
  mismatchMessage
) => {
  if (typeof confirmPassword !== 'string' || confirmPassword.length === 0) {
    return requiredMessage;
  }

  return password === confirmPassword ? VALID : mismatchMessage;
};

export const createSignupPasswordValidator = intl => {
  const passwordRequired = requiredStringNoTrim(
    intl.formatMessage({ id: 'SignupForm.passwordRequired' })
  );
  const passwordMinLength = minLength(
    intl.formatMessage({ id: 'SignupForm.passwordTooShort' }, { minLength: PASSWORD_MIN_LENGTH }),
    PASSWORD_MIN_LENGTH
  );
  const passwordMaxLength = maxLength(
    intl.formatMessage({ id: 'SignupForm.passwordTooLong' }, { maxLength: PASSWORD_MAX_LENGTH }),
    PASSWORD_MAX_LENGTH
  );
  const validatePassword = composeValidators(
    passwordRequired,
    passwordMinLength,
    passwordMaxLength
  );
  const confirmPasswordRequiredMessage = intl.formatMessage({
    id: 'SignupForm.confirmPasswordRequired',
  });
  const passwordMismatchMessage = intl.formatMessage({
    id: 'SignupForm.passwordMismatch',
  });

  return values => {
    const { password, confirmPassword } = values || {};
    const passwordError = validatePassword(password);
    const confirmPasswordError = validatePasswordConfirmation(
      password,
      confirmPassword,
      confirmPasswordRequiredMessage,
      passwordMismatchMessage
    );

    return {
      ...(passwordError ? { password: passwordError } : {}),
      ...(confirmPasswordError ? { confirmPassword: confirmPasswordError } : {}),
    };
  };
};
